<script setup lang="ts">
import Skeleton from 'primevue/skeleton';

</script>

<template>
  <div class="parent">
    <div v-for="(item,index) in 6"  :class="`div${index + 1} skeleton-container`">
      <Skeleton height="100%" border-radius="40px" />
    </div>
  </div>
</template>

<style scoped>

.parent {
  width:90%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 40px;
  height: 117vh;
  padding:20px;
}

.div1 {
  grid-row: span 2 / span 2;
}

.div2 {
  grid-row: span 2 / span 2;
}

.div3 {
  grid-row: span 2 / span 2;
  grid-column-start: 1;
  grid-row-start: 3;
}

.div4 {
  grid-row: span 2 / span 2;
  grid-column-start: 2;
  grid-row-start: 3;
}

.div5 {
  grid-column: span 2 / span 2;
  grid-row: span 3 / span 3;
  grid-column-start: 3;
  grid-row-start: 1;
}

.div6 {
  grid-column: span 2 / span 2;
  grid-column-start: 3;
  grid-row-start: 4;
}

@media screen and (max-width: 1024px) {
  .parent {
    display: flex;
    width: 90vw;
    overflow:hidden;
    gap:30px;
    height: 500px;
  }

  .skeleton-container {
    min-width: 300px;
    height:420px !important;
    width:300px !important;
  }
}

</style>